import { gql } from 'apollo-boost'



export const SEND_USER_FORM = gql`mutation insert_damage_form_submit($make: String = "" , $model: String = "",$model_specific: String = "", $company: String = null, $date: date = null, $email: String = "", $full_name: String = "", $info: String = null, $insurance_company_name: String = null, $insurance_damage_number: String = null, $meter_reading: Int = 10, $overview_image_url: String = "wrong.jpg", $partner_id: String = "e67b281b", $phone: String = "", $postal_code: numeric = null, $reg_nr: String = "" , $session_id: String = "") {
  insert_damage_form_submit(objects: {make: $make, model: $model, model_specific: $model_specific,company: $company, date: $date, email: $email, full_name: $full_name, info: $info, insurance_company_name: $insurance_company_name, insurance_damage_number: $insurance_damage_number, meter_reading: $meter_reading, overview_image_url: $overview_image_url, partner_id: $partner_id, phone: $phone, postal_code: $postal_code, reg_nr: $reg_nr , session_id: $session_id}) {
    returning  {
      id
      partner_id
      reg_nr
      full_name
      meter_reading
      email
      insurance_damage_number
      insurance_company_name
      date
      model
      model_specific
      make
      damaged_areas {
        area_name
      }
    }
  }
}`;


export const SEND_CLOSE_UP_IMAGES = gql`mutation insert_damage_form_submit_damaged_area($area_closeup_image_url: String = "", $area_name: String = "", $form_submit_id: uuid = "") {
  insert_damage_form_submit_damaged_area(objects: {area_closeup_image_url: $area_closeup_image_url, area_name: $area_name, form_submit_id: $form_submit_id}) {
    returning {
      id
    }
  }
}`


